import React from "react";
import { Layout } from "antd";

import Header from "../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";

interface BenefitsInterface {}

const Benefits: React.FC<BenefitsInterface> = () => {
  return (
    <Layout>
      <Header hideSideNav={true} />
      <div className="benefits-page tablebenefits">
        <table>
          <tbody>
            <tr>
              <th>Missing Skincare</th>
              <th> Benefits You’ll Get</th>
            </tr>
            <tr>
              <td>Stress Free Shopping</td>
              <td>
                Everything is done for you. No more conflict which skincare to
                buy.
              </td>
            </tr>
            <tr>
              <td>Ecological How to Use</td>
              <td>
                Step by step skincare routine built with products you already
                have.
              </td>
            </tr>
            <tr>
              <td>100% Cash Back</td>
              <td>
                Help make your friends skincare simple too and get full money
                back.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Layout>
  );
};

export default Benefits;
